import React from "react"
import styled from "styled-components"
import { Link } from "gatsby"

import * as TextStyles from "../styles/TextStyles"

interface Props {
  title: string
  image: string
  slug: string
}

const DeviceCard = (props: Props) => {
  const { title, image, slug } = props

  const link = `/mockups/${slug}`

  return (
    <MyLink to={link}>
      <Title>{title}</Title>
      <Card src={image} alt="device image" />
    </MyLink>
  )
}

export default DeviceCard

const MyLink = styled(Link)`
  position: relative;
  display: grid;
  width: 380px;
  height: 500px;
  text-decoration: none;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.15);
  padding: 40px;
  gap: 20px;
  overflow: hidden;

  &,
  * {
    transition: 0.8s cubic-bezier(0.075, 0.82, 0.165, 1);
  }

  :hover {
    transform: scale(1.05);
  }
`

const Card = styled.img`
  max-width: 300px;
  max-height: 400px;
  margin: 0 auto;
`

const Title = styled(TextStyles.H4)`
  max-width: 280px;
  width: 100%;
  color: #000000;
  padding-right: 20px;
`
